export default __webpack_public_path__ + "static/media/popup-text-mobile.33d4fad4.svg";